export var setStyles = function (container, style) {
    if (style === void 0) { style = {}; }
    var keys = Object.keys(style);
    keys.forEach(function (key) {
        container.style[key] = style[key];
    });
};
